
const newResponseSrcset = (url, maxWidth) => {
    const max = maxWidth;
    const srcset = [];
    const options = [360,512,640,680,768,960,1024,1200,1280,1366,1536].filter((item) => {
      return item <= maxWidth;
    });
    if (maxWidth > options[options.length - 1]) {
      options.push(max);
    }
    for (const item of options) {
      const itemUrl = `${url}?w=${item} ${item}w`;
      srcset.push(itemUrl);
    } 
    return srcset.join(',');
}
export default defineNuxtPlugin(() => {
  return {
    provide: {
      newResponseSrcset,
    },
  };
});
